module.exports = "/assets/6a46950e292f44c707e8e20a13bb885e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CG.png
// module id = 1264
// module chunks = 0